import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=6a08a3d6&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=6a08a3d6&prod&lang=css&"
import style1 from "./Header.vue?vue&type=style&index=1&id=6a08a3d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a08a3d6",
  null
  
)

export default component.exports